import React from 'react';
import { RocketIcon, HardDriveIcon, ShieldCheckIcon } from 'lucide-react';
export function CaseStudiesSection() {
  const cases = [{
    icon: <RocketIcon className="w-6 h-6" data-id="element-120" />,
    tag: 'AI / Machine Learning',
    title: 'AI Startup deploys ML training pipeline in 48 hours',
    description: 'A fast-growing generative AI startup needed dedicated GPU clusters without the unpredictable costs of public cloud. UCenSys provisioned bare-metal infrastructure in two days.',
    metric: '40% Cost Reduction'
  }, {
    icon: <HardDriveIcon className="w-6 h-6" data-id="element-121" />,
    tag: 'Hybrid Cloud Migration',
    title: 'Enterprise migrates 500TB to hybrid cloud with zero downtime',
    description: 'A regional logistics company seamlessly moved their legacy on-premise databases to our secure Atlanta facility, integrating directly with their AWS front-end.',
    metric: 'Zero Downtime'
  }, {
    icon: <ShieldCheckIcon className="w-6 h-6" data-id="element-122" />,
    tag: 'Healthcare Compliance',
    title: 'Healthcare company meets HIPAA compliance with local infrastructure',
    description: 'A medical records processor required strict data sovereignty and physical security. Our SSAE 18 compliant facility provided the exact audit trail they needed.',
    metric: '100% Audit Pass Rate'
  }];
  return <section className="py-24 lg:py-32 bg-ucensys-navy" data-id="element-123">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-124">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-125">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6" data-id="element-126">
            Real Results for Enterprise Teams
          </h2>
          <p className="text-lg font-body text-text-secondary" data-id="element-127">
            See how organizations are leveraging our infrastructure to scale
            faster, reduce costs, and maintain strict compliance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-128">
          {cases.map((study, index) => <div key={index} className="bg-ucensys-card border border-border-color rounded-xl p-8 flex flex-col h-full hover:border-ucensys-teal/40 transition-colors" data-id="element-129">
              <div className="flex items-center gap-3 mb-6" data-id="element-130">
                <div className="w-10 h-10 rounded-full bg-ucensys-navy border border-border-color flex items-center justify-center text-ucensys-teal" data-id="element-131">
                  {study.icon}
                </div>
                <span className="text-xs font-mono text-ucensys-teal uppercase tracking-wider" data-id="element-132">
                  {study.tag}
                </span>
              </div>

              <h3 className="text-xl font-heading font-semibold text-white mb-4 leading-snug" data-id="element-133">
                {study.title}
              </h3>

              <p className="text-text-secondary font-body text-sm leading-relaxed mb-8 flex-grow" data-id="element-134">
                {study.description}
              </p>

              <div className="pt-6 border-t border-border-color mt-auto" data-id="element-135">
                <span className="block text-xs font-body text-text-muted uppercase tracking-wider mb-1" data-id="element-136">
                  Key Result
                </span>
                <span className="text-lg font-heading font-bold text-ucensys-teal" data-id="element-137">
                  {study.metric}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}